module.exports = new __parcel__URL__("business.190990a5.png").toString();